<script lang="ts" setup>
import { computed } from 'vue'
import RoomieButton from '@lahaus-roomie/roomie/src/components/RoomieButton/index.vue'

import type { Props } from './types'
import { getReferralBonus } from '@/utils/referralBonus'

const props = withDefaults(defineProps<Props>(), {
  dataAttributes: {
    dataLh: { P: 'unknown', Z: 'unknown' }
  }
})

const { t, locale } = useI18n()

const bonusWithCurrency = computed(() => getReferralBonus(locale.value, true))
const { $useLhId } = useNuxtApp()

const url = `${t('registerUrl')}?utm_source=${props.sourcePage}&utm_medium=web`

const signUpEvent = () => {
  window.open(url, '_blank').focus()
}
</script>

<script lang="ts">
export default {
  name: 'InterestedSection'
}
</script>

<template>
  <section
    class="interested-section flex flex-row mt-56 justify-between items-center">
    <div class="flex flex-row gap-32">
      <img src="https://assets.lahaus.com/static/svgs/icons/interested_arrow.svg">

      <div class="flex flex-col gap-8">
        <span class="text-white display-6">
          {{ t('title') }}
        </span>

        <span class="text-white body-1-sb">
          {{ t('subtitle', { bonusWithCurrency }) }}
        </span>
      </div>
    </div>

    <RoomieButton
      id="pdp-referral-banner-button-register-now"
      variant="secondary"
      :data-lh-id="$useLhId({ ...dataAttributes.dataLh, A: 'redireccionar', C: t('signUp') })"
      @click="signUpEvent">
      <div>
        {{ t('signUp') }}
      </div>
    </RoomieButton>
  </section>
</template>

<style lang="scss">
.interested-section {
  @apply bg-pine-600 px-48 py-32 rounded-24;

  margin-left: 131px;
  margin-right: 131px;

  #pdp-referral-banner-button-register-now {
    @apply cta-18;
  }
}
</style>

<i18n src="./i18n.json" lang="json" />
